'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index$3$1 = require('../index.js');
const resolveValue = require('../../utils/resolve-value.js');

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */
function resolveMotionValue(value) {
  var unwrappedValue = value instanceof index$3$1.MotionValue ? value.get() : value;
  return resolveValue.isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

exports.resolveMotionValue = resolveMotionValue;
